import { useMemo, useState } from 'react';

/**
 * Case-insensitive client-side search over a collection.
 *
 * @param {Array} items
 * @param {(item: any) => string} getSearchText - must be referentially stable (define it at module level)
 * @returns {{ search: string, setSearch: Function, filteredItems: Array }}
 */
export default function useCollectionSearch(items, getSearchText) {
	const [search, setSearch] = useState('');

	const filteredItems = useMemo(() => {
		const needle = search.trim().toLowerCase();
		if (!needle) return items;
		return items.filter((item) => getSearchText(item).toLowerCase().includes(needle));
	}, [items, search, getSearchText]);

	return { search, setSearch, filteredItems };
}
